import { Text, useDevice, useViewport } from '@treatwell/ui';
import React from 'react';
import styles from './CmsText.module.css';

export const CmsText = ({
  text,
  isParagraph = false,
}: {
  text: string;
  isParagraph?: boolean;
}) => {
  const { isMobile } = useDevice();
  const isMobileViewport = useViewport({
    device: ['mobile', 'tablet'],
    serverRender: isMobile,
  });

  return (
    <Text
      as={isParagraph ? 'p' : 'span'}
      type={isMobileViewport ? 'caption' : 'body'}
    >
      <span
        className={styles.text}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </Text>
  );
};
